const authBasePath = '/v1/cms/auth';

const authEndpoints = {
  register: `${authBasePath}/register`,
  login: `${authBasePath}/login`,
  verifyLoginCode: `${authBasePath}/verify-login-code`,
  forgotPassword: `${authBasePath}/forgot-password`,
  resetPassword: `${authBasePath}/reset-password`,
  session: `${authBasePath}/session`,
  logout: `${authBasePath}/logout`
};

export default authEndpoints;
